export const ServerAppSettings = Object.freeze({
  keys: Object.freeze({
    enableOom: 'enableOom',
    /**
     * （仅支持ANR的端支持，例如安卓、鸿蒙）莉莉丝需求，是否支持“崩溃+ANR“合并的新指标。（这个是系统超管控制，用来决定哪些项目可以在设置页面看到showVitalCategoryAsDefault开关）
     * --story=127642761 【CS】【莉莉丝】大盘崩溃统计新增崩溃+ANR合并模式
     * */
    enableVitalCategory: 'enableVitalCategory',
    /**
     * （仅支持ANR的端支持，例如安卓、鸿蒙）莉莉丝需求，对于配置了enableVitalCategory的项目，项目管理员可以在配置界面设置是否启用合并崩溃指标（界面上直接取代原来的崩溃指标）
     * --story=127642761 【CS】【莉莉丝】大盘崩溃统计新增崩溃+ANR合并模式
     * */
    showVitalCategoryAsDefault: 'showVitalCategoryAsDefault',
    enableFeatureAnalysis: 'enableFeatureAnalysis',
    /** 特征分析，是否支持正则匹配规则 */
    enableRegexpQueryType: 'enableRegexpQueryType',
    /** @deprecated 现在特征全部支持标签方式 */
    // enableFeatureAnalysisRealtimeTag: 'enableFeatureAnalysisRealtimeTag',
    enableIssueRegroup: 'enableIssueRegroup',
    enableErrorRetrace: 'enableErrorRetrace',
    /** @deprecated 页面上是否支持启动次数和次数崩溃率（PC商业化项目默认是隐藏的），目前这个开关已经废弃，现在是全量开放 */
    // enableDashboardAccessCount: 'enableDashboardAccessCount',
    /** 页面上是否开启和平项目定制的 OOM 单维度 TOP 排行组件  --story=131355670 【CS】【P0】【和平】OOM崩溃统计分析改造 */
    enableOomAdvancedFieldTopRanking: 'enableOomAdvancedFieldTopRanking',
    enableAiAnalyse: 'enableAiAnalyse',
    enableSdkStrategyConfig: 'enableSdkStrategyConfig',
    enableIssueLifetimeAllDataStats: 'enableIssueLifetimeAllDataStats',
    enableCustomErrorTypes: 'enableCustomErrorTypes',
    ignoreCustomKeyType: 'ignoreCustomKeyType', // DFM项目用的，--story=118169915 【CS】【DFM】兼容目前DFM线上版本，字符型的自定义kv，也要支持当作数值型kv存储数值并支持直方图
    commonSequenceCustomKeyList: 'commonSequenceCustomKeyList',
    /** 项目是否开启AI问题分类。这个开关前后台都要用到 */
    enableAiIssueGrouping: 'enableAiIssueGrouping',
    enableOnlineRetrace:'enableOnlineRetrace', // 已废弃，现在在线还原是全量开放了
    enableSubModuleId: 'enableSubModuleId',
    /** （NGR需求）项目上传的SDK log是否有内部中间件加密，下载的时候需要解密  */
    enableDecryptSdkLog: 'enableDecryptSdkLog',
    /** 页面上大盘是否支持选择场景维度 */
    enableUserSceneTag: 'enableUserSceneTag',
    /** 元梦需求，页面上的场景字段（UserSceneTag）的自定义显示名字（中文） */
    customUserSceneTagLabelZh: 'customUserSceneTagLabelZh',
    /** 元梦需求，页面上的场景字段（UserSceneTag）的自定义显示名字（英文） */
    customUserSceneTagLabelEn: 'customUserSceneTagLabelEn',
    /** 项目是否支持“重新打开”的问题状态。 */
    enableIssueStatusReopened: 'enableIssueStatusReopened',
    /** @deprecated 曾用于控制安卓端过滤器是否支持GPU字段搜索，现安卓GPU搜索已全量开放，不再读取此开关，保留定义仅为兼容历史配置数据 */
    enableAndroidSearchGpu: 'enableAndroidSearchGpu',
    disableStatsByCountry: 'disableStatsByCountry', // 异常概览中是否关闭按国家维度统计详情
    enableDevicesPercentage: 'enableDevicesPercentage', // 异常概览中是否展示32位CPU占比
    pcClassify:'pcClassify',
    dailyReportSetting: 'dailyReportSetting',
    enablePcLogTrace: 'enablePcLogTrace', // 崩溃详情-跟踪日志TAB下，堆栈还原按钮的开关。
    enableIssueMerge: 'enableIssueMerge', // 支持多issue合并
    enableAdvancedTrend: 'enableAdvancedTrend', // 支持趋势对比
    /** Issue查看页上报趋势是否展示「最近90天（天粒度）」选项。仅部分项目CK有90天日粒度数据，由超管按项目开启。 --story=137032751 */
    enableIssueTrendLast90Days: 'enableIssueTrendLast90Days',
    /** 页面上是否支持洞察分析 */
    enableInsightPage: 'enableInsightPage',
    tapdFieldList: 'tapdFieldList', // 页面上TAPD提单的时候，表单中配置展示的字段列表
    /**
     * 项目级「默认提单模板」，对两个提单入口同时生效：
     * 手动提单弹窗打开时的初始选中模板；特征分析自动提单新建规则时的预填模板（已保存规则不受影响）。
     * 取值：不存在/__TAPD_DEFAULT__=跟随TAPD默认模板，__NONE__=不使用模板，其它=模板id。
     * https://tapd.woa.com/tapd_fe/20421727/story/detail/1020421727138399301
     */
    tapdBugDefaultTemplate: 'tapdBugDefaultTemplate',
    /** 页面上Jira提单的时候，字段的默认值。对应的java后端类型是Map<String, Object> */
    jiraFieldDefaultValue: 'jiraFieldDefaultValue',
    /**
     * 页面上Jira提单的时候，Team字段（Jira 官方 Atlassian Team 自定义字段）的可选项。
     * 原始CSV文本，每行「团队名,Team UUID」。默认团队复用 jiraFieldDefaultValue。
     * https://tapd.woa.com/tapd_fe/20421727/story/detail/1020421727138529159
     */
    jiraTeamOptions: 'jiraTeamOptions',
    /** 叠纸需求，2.0页面上报详情把channelId字段去掉了，但是部分旧的项目还在用，此开关控制是否支持显示旧的channelId字段。
     * https://tapd.woa.com/tapd_fe/20421727/story/detail/1020421727120685673 */
    enableReportFieldChannelId: 'enableReportFieldChannelId',
    /** 页面上成员管理是否可以批量添加/删除人员。 https://tapd.woa.com/tapd_fe/20421727/story/detail/1020421727120718765 */
    enableBatchAddOrDeleteMembers: 'enableBatchAddOrDeleteMembers',
    /** OOM页面上是否能看到“崩溃系统强杀类型”过滤器 */
    enableOomStatusFilter: 'enableOomStatusFilter',
    /** 高级搜索是否支持搜索app so白名单字段 */
    enableFilterAppSoNameWhitelist: 'enableFilterAppSoNameWhitelist',
    /** 高级搜索是否支持从CRASH EXTRA集群搜索用户自定义日志（printLog） */
    enableFilterPrintLog: 'enableFilterPrintLog',
    /** 高级搜索、特征分析是否支持搜索"签名渠道"字段（checkedChannel）。部分项目需要支持，由超管控制开关 */
    enableFilterCheckedChannel: 'enableFilterCheckedChannel',
    /** 新增告警规则里APP告警下拉框是否支持自定义webhook */
    enableAlarmCustomWebhook: 'enableAlarmCustomWebhook',
    /** @deprecated 已由 enableOom 替代。自定义告警 OOM 大类的可见性现在统一由 enableOom 控制（不再限制 iOS）。历史遗留，保留 key 以免 JSON 解析异常，但前端不再读取。 */
    enableAlarmOomCategory: 'enableAlarmOomCategory',
    /** 商业化项目：是否支持展示、搜索VmType的云游戏选项。非商业化项目不受此开关控制，全部展示 */
    enableVmTypeCloudGaming: 'enableVmTypeCloudGaming',
    /** HoK需求，大盘统计，默认展示的vm type */
    dashboardDefaultVmType: 'dashboardDefaultVmType',
    /** 大盘统计，默认展示的sub module id（发行渠道）。 --story=128575863 【CS】【轻游梦工坊】发行渠道支持默认显示指定渠道  */
    dashboardDefaultSubModuleId: 'dashboardDefaultSubModuleId',
    /** 王者需求，是否支持自定义卡顿类型。 */
    enableJank: 'enableJank',
    /** 王者需求，是否支持自定义卡顿类型。 */
    enableHang: 'enableHang',
    /** PC 项目：卡死分析下拆 PresentHang / GTHang。超管功能配置，默认关。 */
    enablePcHangSplit: 'enablePcHangSplit',
    /** 错误下 ThreadMonitor 子菜单。超管功能配置，默认关。 */
    enableThreadMonitor: 'enableThreadMonitor',
    /** iOS项目，是否开启MetricKit分析页面入口 */
    enableMetricKit: 'enableMetricKit',
    /** Android 项目，是否开启 ApplicationExitInfo（应用退出信息）分析页面入口 */
    enableApplicationExit: 'enableApplicationExit',
    /** 高级搜索按项目开关支持检索归档存储上报 */
    enableSearchArchivedReports: 'enableSearchArchivedReports',
    /** 问题详情页是否开启异常维度偏斜速览、设备信息按偏斜排序与问题重分类免配置调用链变体卡片（超管功能配置，默认关） */
    enableIssueOutlierAndVariants: 'enableIssueOutlierAndVariants',
    /** 问题详情页跟踪日志是否开启崩溃前事件时间轴（Crash Timeline）视图切换（超管功能配置，默认关） */
    enableCrashEventTimeline: 'enableCrashEventTimeline',
    /** 问题详情页透出同设备本次启动会话前置异常因果提示，并提供仅看本次启动会话（超管功能配置，默认关） */
    enableSameLaunchSessionHint: 'enableSameLaunchSessionHint',
    /** 项目是否显示usym符号表。--story=128305301 【CS】【鹰角】Usym符号表提示增加说明或者按照项目开启 */
    enableUsym: 'enableUsym',
    /** DFM定制需求，对于GPU崩溃，是否从相同session的错误上报里面关联GPU Breadcrumbs信息。 */
    associateGpuCrashInfoWithError: 'associateGpuCrashInfoWithError',
    /** 海外iGame定制需求，大盘实时趋势与实时TOP问题是否开启10分钟粒度（144点/天）及点击联动 */
    enableTenMinuteTrend: 'enableTenMinuteTrend',
    /** 是否是先锋云游戏项目。 */
    isAppGameMatrix: 'isAppGameMatrix',
    /**
     * iGame需求。高级趋势页面，支持过滤的自定义key的白名单。因为CK那边要节省存储，所以只有白名单里面的key才存储。 --story=128801316 【CS】【P0】【iGame】对iGame放开高级趋势查询，支持按自定义kv过滤
     * 存储的key带K#, I#前缀。 但是不带C03_前缀。
     * */
    advancedTrendCustomKeyWhitelist: 'advancedTrendCustomKeyWhitelist',
  }),
});
